"use strict";
// import Vue from 'vue';
import axios from "axios";
import {baseURL} from "@/config";
import {getToken, loginTimeOut, TOAST, toast} from "@/utils/utils";
import Qs from 'qs';

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = baseURL
//  if headers need token
// axios.defaults.headers.common['token'] = getToken();
let config = {
    timeout: 60 * 1000, // Timeout
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    // }
};
const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    response => {
        if (response.config.responseType === 'blob') {
            return response
        }
        if (response.data.status === 901) {
            loginTimeOut()
        }else {
            return response.data
        }
    },
    error => {
        let code = 0
        try {
            code = error.response.data.status
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                toast('网络请求超时',TOAST.error)
                return Promise.resolve(error)
            }else if (error.toString().indexOf('Error: Network Error') !== -1) {
                toast('网络请求错误',TOAST.error)
                return Promise.resolve(error)
            }
        }
        if (code === 5000) {
            loginTimeOut()
        }
        return Promise.resolve(error)
    }
);

// 封装get方法和post方法
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        _axios.get(url, {
            params: {...params, ...getToken()}
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err)
        })
    });
}

/**
 * getfile方法，对应get请求流文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getfile(url, params) {
    return new Promise((resolve, reject) => {
        _axios.get(url, {
            params: {...params, ...getToken()},
            responseType: 'blob'
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        _axios.post(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * upload方法，upload
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function upload(url, params) {
    return new Promise((resolve, reject) => {
        _axios.post(url, params,{ headers : { 'Content-Type': 'multipart/form-data'}})
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * postfile方法，对应post请求流文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postfile(url, params) {
    return new Promise((resolve, reject) => {
        _axios.post(url, Qs.stringify(getToken() ? {...params, ...getToken()}  : params), {responseType: 'blob'})
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * qspost方法，参数序列化
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function qspost(url, params) {
    return new Promise((resolve, reject) => {
        _axios.post(url, Qs.stringify(getToken() ? {...params, ...getToken()}  : params))
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}
/**
 * qspost方法，参数序列化
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function qspost2(url, params) {
  return new Promise((resolve, reject) => {
    _axios.post(url, Qs.stringify(params))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        _axios.put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * delete
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletefn(url, params) {
    return new Promise((resolve, reject) => {
        _axios.delete(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}